import { SxProps, Theme } from "@mui/material/styles";

export const keyDetailsContainer: SxProps<Theme> = (theme) => ({
    marginTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
});

export const keyDetailsTitle: SxProps<Theme> = (theme) => ({
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontFamily: "HsvSlab",
    marginBottom: theme.spacing(2),
});
